export default "__VITE_ASSET__C$FmOUn___"